var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("modal-pop", {
        attrs: {
          opened: _vm.isPopupOpen,
          modalHeader: true,
          modalFooter: true,
          btnClose: false,
          title: "FIDO-0077"
        },
        on: {
          "update:opened": function($event) {
            _vm.isPopupOpen = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", {}, [
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*은행 거래를 위해서는 개인정보수집 동의가 필요합니다.*/ _vm.$t(
                            "FIDO-0078"
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "u",
                      {
                        staticClass: "highlight",
                        on: {
                          click: function($event) {
                            return _vm.fileDown()
                          }
                        }
                      },
                      [_vm._v(_vm._s(/*전문보기*/ _vm.$t("FIDO-0079")))]
                    )
                  ]),
                  _c("br"),
                  _c(
                    "dl",
                    {
                      staticClass: "dlist dlist-item--type4 nomargin text-black"
                    },
                    [
                      _c("dt", [
                        _vm._v(_vm._s(/*처리 목적*/ _vm.$t("FIDO-0080")))
                      ]),
                      _c("dd", {
                        domProps: { innerHTML: _vm._s(_vm.$t("FIDO-0081")) }
                      }),
                      _c("dt", [
                        _vm._v(_vm._s(/*개인정보 유형*/ _vm.$t("FIDO-0082")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            /*민감정보를 포함한 개인정보(이름, 생년월일, 생체정보 등)*/ _vm.$t(
                              "FIDO-0083"
                            )
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*처리 방식*/ _vm.$t("FIDO-0084")))
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            /*개인정보보호법에 의한 처리*/ _vm.$t("FIDO-0085")
                          )
                        )
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*관련 기관*/ _vm.$t("FIDO-0086")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(/*은행 및 제휴사*/ _vm.$t("FIDO-0087")))
                      ]),
                      _c("dt", [
                        _vm._v(_vm._s(/*보유 기간*/ _vm.$t("FIDO-0088")))
                      ]),
                      _c("dd", [
                        _vm._v(_vm._s(/*거래 종료일까지*/ _vm.$t("FIDO-0089")))
                      ]),
                      _c("dt", [
                        _vm._v(
                          _vm._s(
                            /*예상치 못한 결과 및 손해*/ _vm.$t("FIDO-0090")
                          )
                        )
                      ]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            /*고객정보 유출로 인해 신원도용이나 사기가 발생할 수 있으며, 은행은 피해 최소화를 위해 즉각 조치를 취함.*/ _vm.$t(
                              "FIDO-0091"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _c("br"),
                  _c("p", [
                    _vm._v(
                      _vm._s(/*위 내용에 동의하십니까?*/ _vm.$t("FIDO-0092"))
                    )
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom negative",
                    on: {
                      click: function() {
                        _vm.isNoPopupOpen = true
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("FIDO-0093")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function() {
                        _vm.RBF060AB61Call()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("FIDO-0094")) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened: _vm.isNoPopupOpen,
          modalHeader: true,
          modalFooter: true
        },
        on: {
          "update:opened": function($event) {
            _vm.isNoPopupOpen = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      /*은행 거래를 위해서는 개인정보수집 동의가 필수입니다.*/ _vm.$t(
                        "FIDO-0095"
                      )
                    )
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function() {
                        _vm.isNoPopupOpen = false
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(/*확인*/ _vm.$t("FIDO-0096")) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }